// Where the cabinet talks to, picked by the host it is served from. There is no build: the same files go to the dev
// and the production bucket, and the address bar says which one this is. Anything else (localhost) is a
// developer's machine and talks to dev.
//
// The values are the Blazor app's appsettings.Production.json, appsettings.Staging.json and appsettings.json, which
// this replaces. None of them is a secret: every one of them was in a world-readable JSON file before.

const PRODUCTION = {
    environment: 'Production',
    influencerApiUrl: 'https://api-influencer.lifyapp.com',
    mainApiUrl: 'https://api.lifyapp.com',
    deepLinkUrl: 'lify.influencer://open',
    identity: {
        clientId: 'ea6be2c4-a6ec-46fc-a65c-fd6fe3cb7dba',
        publicUrl: 'https://identity.lifyapp.com/oauth/login',
        tokenUrl: 'https://api-identity.lifyapp.com/oauth/token'
    }
};

const STAGING = {
    environment: 'Staging',
    influencerApiUrl: 'https://api-influencer.branch.healthpassport.pro',
    mainApiUrl: 'https://api.branch.healthpassport.pro',
    deepLinkUrl: 'lify.influencer.dev://open',
    identity: {
        clientId: '63b64174-e798-44c4-8021-040ef5b517b5',
        publicUrl: 'https://identity.branch.healthpassport.pro/oauth/login',
        tokenUrl: 'https://api-identity.branch.healthpassport.pro/oauth/token'
    }
};

// The Firebase Web app web push registers against. Public client identifiers, readable in any browser that loads the
// cabinet; the FCM service account that sends is on the backend.
const FIREBASE = {
    apiKey: 'AIzaSyAXeENMkX4kxVEzj1ag-pnZvpRPnvIkkHk',
    authDomain: 'lifyapp.firebaseapp.com',
    projectId: 'lifyapp',
    messagingSenderId: '578100825111',
    appId: '1:578100825111:web:134e25fca103f1e5a32052',
    vapidKey: 'BPJajmZB7EacCw8zJ9aid9jlIi9gWOklU55juMsprYca7Dmikb6LSZGot43rBvTPxfRzNjtv9MODnCJ12C3h5Ls'
};

function pick(host: string): typeof STAGING {
    if (host === 'influencer.lifyapp.com') return PRODUCTION;
    if (host === 'influencer.branch.healthpassport.pro') return STAGING;
    return { ...STAGING, environment: 'Local' };
}

export const config = { ...pick(location.hostname), firebase: FIREBASE };
